import FourDotLoader from './FourDotLoader.component';

export default FourDotLoader;
